// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { ShowRowContent, ShowDetails } from '@/lib/types/api/show-data';

// components
import MyListShowPoster from '@/components/MyList/MyListShows/MyListShowPoster';

// styles
import styles from './MyListShowPosterGrid.module.scss';

interface MyListShowPosterGridProps {
  shows: (ShowRowContent | ShowDetails)[];
  showMyStationBadge?: boolean;
}

const MyListShowPosterGrid = (props: MyListShowPosterGridProps) => {
  const { shows, showMyStationBadge } = props;
  return (
    <div className={styles.my_list_show_poster_grid} data-sentry-component="MyListShowPosterGrid" data-sentry-source-file="MyListShowPosterGrid.tsx">
      {shows.map((show, i: number) => {
        return (
          <MyListShowPoster show={show as ShowRowContent} key={i} showMyStationBadge={showMyStationBadge} />
        )
      })}
    </div>
  );
};

export default MyListShowPosterGrid;
